// extracted by mini-css-extract-plugin
export var avatarContainer = "_5z-0";
export var avatarTypingWave = "_5z-i";
export var gray = "_5z-f";
export var green = "_5z-c";
export var icon = "_5z-9";
export var image = "_5z-1";
export var lg = "_5z-6";
export var md = "_5z-5";
export var presenceDot = "_5z-b";
export var red = "_5z-d";
export var sm = "_5z-4";
export var status = "_5z-a";
export var typingDot = "_5z-h";
export var typingPill = "_5z-g";
export var xl = "_5z-7";
export var xs = "_5z-3";
export var xxl = "_5z-8";
export var xxs = "_5z-2";
export var yellow = "_5z-e";